import { createContext, useContext } from 'react';
import { useStore } from 'zustand';
import { makeProjectsStore, type ProjectsState, type ProjectsStoreApi } from './useProjectsStore';

/**
 * Default lazily-created store that uses the real Dexie-backed storage.
 * Tests pass their own store via ProjectsStoreContext.Provider so they
 * don't accidentally hit IndexedDB through this singleton. The fallback
 * is exercised in Playwright (real browser) and excluded from unit coverage
 * so disk stays an external boundary.
 */
/* v8 ignore start */
let defaultStoreCache: ProjectsStoreApi | null = null;

function getDefaultStore(): ProjectsStoreApi {
  if (!defaultStoreCache) {
    defaultStoreCache = makeProjectsStore();
  }
  return defaultStoreCache;
}
/* v8 ignore stop */

export const ProjectsStoreContext = createContext<ProjectsStoreApi | null>(null);

export function useProjectsStoreApi(): ProjectsStoreApi {
  /* v8 ignore next */
  return useContext(ProjectsStoreContext) ?? getDefaultStore();
}

export function useProjects<T>(selector: (state: ProjectsState) => T): T {
  const store = useProjectsStoreApi();
  return useStore(store, selector);
}
